export const contractAddress = '0x112f12ed13ed632699c7fe52f0bddefab819bae5';
export const tokensContract = '0xd9e77a87daaec5818c95fe0a677839edac736274';
